import { Table } from "react-bootstrap";

export default function F23Schedule() {
    return <>
        <h2>Schedule</h2>
        <p>All course content is available <a href="https://github.com/CS571-F23">via GitHub Classroom!</a> You may download <a target="_blank" href="https://github.com/ctnelson1997/cs571-org/blob/master/cs571_f23_syllabus.pdf">the syllabus here</a>. Course grading details <b>are provided below the schedule.</b> (N) links to notes and (R) links to recording of the lecture.</p>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Week Of</th>
                    <th>Topics</th>
                    <th>Homework</th>
                    <th>Quiz</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Sept 4<br/></td>
                    <td>Intro to CS571 <a href="https://drive.google.com/file/d/1gAl80JxQgcywQi_t8lpuDQ9L8IhuqRnp/view?usp=sharing" target="_blank">(N-11a)</a> <a href="https://mediaspace.wisc.edu/media/CS571-Introduction+%28SEC+001%29+Yuhang+Zhao-Science+180-09+07+23-11A00A48/1_ljdx1m38" target="_blank">(R-11a)</a> <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week01/Week01-Intro/week01-intro.pdf">(N-4p)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_c2vu9su2">(R-4p)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw0">HW0</a> (1 pt)</td>
                    <td>No Quiz</td>
                </tr>
                <tr>
                    <td>Sept 11<br/></td>
                    <td>JavaScript 1 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week02/Week02-JS1/week02-js1.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_e9wrk05v">(R)</a> & Design Thinking <a target="_blank" href="https://drive.google.com/file/d/10bpCdFZYpOG3rq4BRQg2WU_ieZ3TgvPM/view?usp=sharing">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Clip+of+Yuhang+Zhao-Science+180-09+14+23-10A57A10/1_p3lt6cxj">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw1">HW1</a></td>
                    <td>Quiz A</td>
                </tr>
                <tr>
                    <td>Sept 18<br/></td>
                    <td>JavaScript 2 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week03/Week03-JS2/week03-js2.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_pizuie3v">(R)</a> & JavaScript 3 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week03/Week03-JS3/week03-js3.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_dafyert4">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw2">HW2</a></td>
                    <td>Quiz B</td>
                </tr>
                <tr>
                    <td>Sept 25<br/></td>
                    <td>React 1 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week04/Week04-React1/week04-react1.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_fr5cdh2p">(R)</a> & Visual Design <a target="_blank" href="https://drive.google.com/file/d/11DlB3ygDNbthvJnXTFXy179kZlVXQYH_/view?usp=sharing">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Yuhang+Zhao-Educational+Sciences+204-09+28+23-15A56A05/1_rqhq0cgk">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw3">HW3</a></td>
                    <td>Quiz C</td>
                </tr>
                <tr>
                    <td>Oct 2<br/></td>
                    <td>React 2 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week05/Week05-React2/week05-react2.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_mtr1zl7f">(R)</a> & Web Design <a target="_blank" href="https://drive.google.com/file/d/1vswYXLsgEHhQOmVbarbSHu69G9tIniDI/view?usp=sharing">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/w05-webdesign/1_2x54fh9g">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw4">HW4</a></td>
                    <td>Quiz D</td>
                </tr>
                <tr>
                    <td>Oct 9<br/></td>
                    <td>React 3 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week06/Week06-React3/week06-react3.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_sgo82nya">(R)</a> & Interaction Design <a target="_blank" href="https://canvas.wisc.edu/courses/376033/files/34798977?module_item_id=6623231">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Temporary+Passcode-Science+180-10+12+23-10A50A32/1_nf7ejdyr">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw5">HW5</a></td>
                    <td>Quiz E</td>
                </tr>
                <tr>
                    <td>Oct 16<br/></td>
                    <td>React 4 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week07/Week07-React4/week07-react4.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_ja48n6os">(R)</a> & Accessibility <a target="_blank" href="https://drive.google.com/file/d/19IJeeB7JG29HU70Y1l1qpHSLwzvDw6nU/view?usp=sharing">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Yuhang+Zhao-Science+180-10+19+23-10A59A19/1_kfg1qpuw">(R)</a> </td>
                    <td><a href="https://github.com/CS571-F23/hw6">HW6</a></td>
                    <td>Quiz F</td>
                </tr>
                <tr>
                    <td>Oct 23<br/></td>
                    <td>React 5 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week08/Week08-React5/week08-react5.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_6mi8zvp5">(R)</a> & <strong>Midterm Exam</strong></td>
                    <td>No HW</td>
                    <td>No Quiz</td>
                </tr>
                <tr>
                    <td>Oct 30<br/></td>
                    <td>React Native 1 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week09/Week09-ReactNative1/week09-reactnative1.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_04wg1cfh">(R)</a> & Prototyping <a target="_blank" href="https://canvas.wisc.edu/courses/376033/files/35244480?module_item_id=6658028">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Yuhang%20Zhao-Science%20180-11_02_23-10%3A58%3A26/1_b68jezc7">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw7">HW7</a></td>
                    <td>Quiz G</td>
                </tr>
                <tr>
                    <td>Nov 6<br/></td>
                    <td>React Native 2 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week10/Week10-ReactNative2/week10-reactnative2.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_30t9q3q6">(R)</a> & Mobile Design <a target="_blank" href="https://drive.google.com/file/d/1CeQcWGw9JAw3aXbAakmUsN6e7eD9PfEN/view?usp=sharing">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Yuhang+Zhao-Educational+Sciences+204-11+09+23-15A55A28/1_e0bwtf1s">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw8">HW8</a></td>
                    <td>Quiz H</td>
                </tr>
                <tr>
                    <td>Nov 13<br/></td>
                    <td>React Native 3 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week11/Week11-ReactNative3/week11-reactnative3.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_zk0lovnu">(R)</a> & VUI Design/Exp Prototyping <a target="_blank" href="https://drive.google.com/file/d/1E2Zfp3IDfa18Ay_hbFh6H5zh3otxtn4W/view">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Yuhang+Zhao-Science+180-11+16+23-10A56A20/1_0h91cwek">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw9">HW9</a></td>
                    <td>Quiz I</td>
                </tr>
                <tr>
                    <td>Nov 20<br/></td>
                    <td>DialogFlow 1 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week12/Week12-DialogFlow1/week12-dialogflow1.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_9b4v8l3j">(R)</a> & <strong>Thanksgiving</strong></td>
                    <td><a href="https://github.com/CS571-F23/hw10">HW10</a> (2 pts)</td>
                    <td>Quiz J</td>
                </tr>
                <tr>
                    <td>Nov 27<br/></td>
                    <td>DialogFlow 2 <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week13/Week13-DialogFlow2/week13-dialogflow2.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_2f3gkrg5">(R)</a> & User Evaluation <a target="_blank" href="https://drive.google.com/file/d/1Ed8ktDauv-p7dBJIbwpJTPVwj9o6dccB/view?usp=drivesdk">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Yuhang%20Zhao-Science%20180-11_30_23-11%3A01%3A25/1_ryocb57o">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw11">HW11</a></td>
                    <td>Quiz K</td>
                </tr>
                <tr>
                    <td>Dec 4<br/></td>
                    <td>FullStack Development <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week14/Week14-FullstackDev/week14-fullstack.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_1n18zyn6">(R)</a> & Expert Evaluation <a target="_blank" href="https://drive.google.com/file/d/1HeVHRab9Lb6PfyWTBh39uyW18NNFqC7E/view?usp=sharing">(N)</a> <a target="_blank" href="https://mediaspace.wisc.edu/media/Yuhang+Zhao-Educational+Sciences+204-12+07+23-16A02A10/1_11qmf860">(R)</a></td>
                    <td><a href="https://github.com/CS571-F23/hw12">HW12</a> (1 pt)</td>
                    <td>Quiz L</td>
                </tr>
                <tr>
                    <td>Dec 11<br/></td>
                    <td>Secure User Interfaces <a target="_blank" href="https://github.com/CS571-F23/lectures/blob/main/Week15/Week15-BuildingSUIs/week15-suis.pdf">(N)</a> <a target="_blank" href="https://cdnapisec.kaltura.com/p/1660902/sp/166090200/embedIframeJs/uiconf_id/25717641/partner_id/1660902?iframeembed=true&playerId=kaltura_player&entry_id=1_s7oqdw44">(R)</a> & <strong>Study Day</strong></td>
                    <td>No HW</td>
                    <td>Bonus Quiz</td>
                </tr>
                <tr>
                    <td>Dec 18<br/></td>
                    <td><strong>Final Exam</strong></td>
                    <td>No HW</td>
                    <td>No Quiz</td>
                </tr>
            </tbody>
        </Table>
        <h2>Grading</h2>
        <p>This is primarily <b>a project-based course.</b></p>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Item</th>
                    <th>Weight</th>
                    <th>Notes</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Weekly Assignments</td>
                    <td>54</td>
                    <td>10 HWs (5 pts) & 3 HWs (1-2 pts each)</td>
                </tr>
                <tr>
                    <td>Weekly Quizzes</td>
                    <td>11</td>
                    <td>12 quizzes, 1 pt each, lowest dropped</td>
                </tr>
                <tr>
                    <td>Midterm Exam</td>
                    <td>15</td>
                    <td>Single-sided notesheet</td>
                </tr>
                <tr>
                    <td>Final Exam</td>
                    <td>20</td>
                    <td>Double-sided notesheet</td>
                </tr>
            </tbody>
        </Table>

        <p>There is no rounding of grades.</p>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Score</th>
                    <th>Grade</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>[93, 100]</td>
                    <td>A</td>
                </tr>
                <tr>
                    <td>[88, 93)</td>
                    <td>AB</td>
                </tr>
                <tr>
                    <td>[80, 88)</td>
                    <td>B</td>
                </tr>
                <tr>
                    <td>[75, 80)</td>
                    <td>BC</td>
                </tr>
                <tr>
                    <td>[70, 75)</td>
                    <td>C</td>
                </tr>
                <tr>
                    <td>[60, 70)</td>
                    <td>D</td>
                </tr>
                <tr>
                    <td>[0, 60)</td>
                    <td>F</td>
                </tr>
            </tbody>
        </Table>
    </>
}